import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-[108rem] overflow-clip flex-none flex justify-end" }
const _hoisted_2 = ["src"]



	import {
		useBrand
	} from '@/utilities/brand'

	
	const __default__ = { name: 'CardHeaderBackdrop' } // name the component

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
		class: {
			type: String,
			default: "opacity-30"
		}
	},
  setup(__props) {

	const props = __props

	const brand = useBrand()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['hidden sm:flex absolute top-0 inset-x-0 justify-center overflow-hidden pointer-events-none', props.class])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("picture", null, [
        _createElementVNode("img", {
          src: _unref(brand).cardHeaderBg,
          alt: "",
          class: "w-[71.75rem] flex-none max-w-none dark:hidden scale-x-[-1]",
          decoding: "async"
        }, null, 8, _hoisted_2)
      ])
    ])
  ], 2))
}
}

})